import axios, { AxiosInstance } from 'axios';

/*
creates an axios http client which will be used for the whole app.
I couldn't get it to work right without specifying the baseURL.  If we wanted to allow it to go to other domains, we'll have to figure out how to get of that prop
 */
const client: AxiosInstance = axios.create();

const errorListeners = [];

client.interceptors.response.use(
    (response) => response, // response is successful
    (error) => {
        if (error.response && error.response.status === 401) {
            errorListeners.forEach((cb) => cb(error));
        }
        return Promise.reject(error);
    }
);

/*
Immediately returns the instance of the client when imported
 */
export default (function $http() {
    return client;
})();

export function setHeader(name: string, value: string): void {
    if (client) {
        client.defaults.headers.common[name] = value;
    }
}

/*
Sets the auth header for all future requests using this client
 */
export function setAuthHeader(token: string): void {
    setHeader('authorization', token);
}

export function listenForAuthErrors(callback) {
    errorListeners.push(callback);
}
